var formValidation = require('./formValidation');
var $cache = {
    window: $(window),
    body: $('body'),
};
var $productDetail = $cache.body.find('.product-detail');
var $cartDetail = $cache.body.find('.cart-detail');
var $form = $productDetail.find('form.add-to-cart');

function updateProduct(data, action) {
    if (data && data.variationProduct) {
        var selectedProduct = data.variationProduct.selectedProduct;
        $productDetail.find('.product-price .value').text(selectedProduct.price.sales.formatted);
        $productDetail.find('.variation-price .price').text(selectedProduct.price.sales.formatted);
        $productDetail.find('input#sku').val(selectedProduct.SKU);
        $productDetail.find('input#quantity').attr('max', selectedProduct.quantity);
        $productDetail.find('input#quantity').val(1);

        // Refresh strikethrough list price + savings %.
        var price = selectedProduct.price;
        var $pricing = $productDetail.find('.pricing');
        var $aux = $pricing.find('.price-aux');
        if (price.list && price.list.value && price.list.value > price.sales.value) {
            var pct = Math.round((1 - (price.sales.value / price.list.value)) * 100);
            var auxHtml = '<span class="price-was">السعر السابق ' + price.list.formatted + '</span>'
                + '<span class="price-pct">— وفّر ' + pct + '%</span>';
            if ($aux.length) {
                $aux.html(auxHtml);
            } else {
                $pricing.find('.price-now').after('<div class="price-aux">' + auxHtml + '</div>');
            }
        } else {
            $aux.remove();
        }

        if (selectedProduct.quantity < 1) {
            $productDetail.find('.buy-now-link').addClass('disabled');
            $productDetail.find('.add-to-cart').addClass('disabled');
        } else {
            $productDetail.find('.buy-now-link').removeClass('disabled');
            $productDetail.find('.add-to-cart').removeClass('disabled');
        }
    }
}

function getErrorMessage(error, fallback) {
    if (error && error.responseJSON && error.responseJSON.message) {
        return error.responseJSON.message;
    }
    if (error && error.statusText) {
        return error.statusText;
    }
    return fallback || 'Something went wrong. Please try again.';
}

function displayToasterMessage(msg, status) {
    var $toaster = $('#toaster');
    $toaster.html(msg);
    $toaster.addClass(status)
    $toaster.slideDown();
    setTimeout(function () {
       $toaster.slideUp();
    }, 3000);
}

//.custom-quantity-selector input
$productDetail.on('change', '.product-type input', function () {
    const variations = {};

    // Iterate over each variation element
    $cache.body.find('.product-type .variation').each(function () {
        const variableName = 'var_' + $(this).data('variable');
        const selectedValue = $(this).find('input:checked').val();
        variations[variableName] = selectedValue;
    });

    // Build the URL
    var quantity = $productDetail.find('.custom-quantity-selector input').val();
    const base_url = '/Product-Variation';
    const pid = $productDetail.data('pid');
    const queryParams = $.param({ pid: pid, qty: quantity, ...variations });
    const fullUrl = `${base_url}?${queryParams}`;
    // var scrollTop = $productDetail.find('.product-price').offset().top;
    var variable = $(this).closest('.variation').data('variable');
    $.spinner().start();
    $.ajax({
        url: fullUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            updateProduct(data);
            // $('body, html').animate({ scrollTop: scrollTop - 80 }, 600);
            $.spinner().stop();
        },
        error: function (error) {
            displayToasterMessage(getErrorMessage(error), "error")
            $.spinner().stop();
        }
    });
})

// cart update product quantity
$cartDetail.on('change', '.custom-quantity-selector input', function () {
    var $this = $(this);
    // Build the URL
    var quantity = $this.val();
    var sku = $this.closest('.product').data('sku');
    var isPDP = $productDetail.length > 0 ? true : false;
    const base_url = '/updateProduct';
    const queryParams = $.param({ sku: sku, quantity: quantity, isPDP: isPDP});
    const fullUrl = `${base_url}?${queryParams}`;
    $this.closest('.product-card').spinner().start();
    $.ajax({
        url: fullUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            $cartDetail.find('.cart-items').html(data.basketHtml);
            $cartDetail.find('.sub-total .price').html(data.basket.totals.subTotal.formatted);
            $cartDetail.find('.total .price').html(data.basket.totals.grandTotal.formatted);
            $('body').trigger('cart:update', {
                basket: data.basket,
            });
            $this.closest('.product-card').spinner().stop();
        },
        error: function (error) {
            displayToasterMessage(getErrorMessage(error), "error")
            $this.closest('.product-card').spinner().stop();
        }
    });

})
$('body').on('cart:update', function (event, response) {
    if (response && response.basket) {
        if (response.basket.count > 0) {
            $('header').find('.cart').removeClass('empty-cart-header');
        } else {
            $('header').find('.cart').addClass('empty-cart-header');
        }
    }
});
$cartDetail.on('click', '.remove-product', function () {
    var $this = $(this);
    // Build the URL
    var sku = $this.closest('.product').data('sku');
    const base_url = '/removeProduct';
    const queryParams = $.param({ sku: sku});
    const fullUrl = `${base_url}?${queryParams}`;

    // Show confirmation modal
    $('#removeProductModal').modal('show');

    // Set up click event for the confirm button in the modal
    $('#confirmRemoveButton').off('click').one('click', function() {
        $.spinner().start();
        $.ajax({
            url: fullUrl,
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                $cartDetail.find('.cart-items').html(data.basketHtml);
                $cartDetail.find('.sub-total .price').html(data.basket.totals.subTotal.formatted);
                $cartDetail.find('.total .price').html(data.basket.totals.grandTotal.formatted);
                if (data.basket.count <= 0) {
                    $cartDetail.addClass('d-none');
                    $('.empty-cart').removeClass('d-none');
                }
                $('body').trigger('cart:update', {
                    basket: data.basket,
                });
                $.spinner().stop();
            },
            error: function (error) {
                displayToasterMessage(getErrorMessage(error), "error")
                $.spinner().stop();
            }
        });

        $('#removeProductModal').modal('hide');
    });
});

$cache.body.on('click', 'button.add-to-cart', function () {
    var quantity = $productDetail.find('.custom-quantity-selector input').val();
    var formData = {
        sku: $productDetail.find('input#sku').val(),
        quantity: quantity
    }
    $.spinner().start();
    $.ajax({
        type: 'POST',
        url: '/addProduct',
        data: formData,
        success: function (data) {
            $('body').trigger('cart:update', {
                basket: data.basket,
            });
            displayToasterMessage(data.message, data.success ? 'valid' : 'error')
            $.spinner().stop();
        },
        error: function (error) {
            displayToasterMessage(getErrorMessage(error), "error")
            $.spinner().stop();
        }
    });
})

$cache.body.on('click', '.buy-now-link', function () {
    const base_url = '/getBuyNowForm';
    var sku = $productDetail.find('input#sku').val();
    var quantity = $productDetail.find('.custom-quantity-selector input').val();
    var store = $productDetail.find('input#store').val()
    const queryParams = $.param({ sku: sku, quantity : quantity, store: store});
    const fullUrl = `${base_url}?${queryParams}`;
    $.spinner().start();
    $.ajax({
        url: fullUrl,
        method: 'GET',
        dataType: 'html',
        success: function (data) {
            $('#buyNowModal .modal-body').html(data);
            formValidation.verifyInputs();
            $('#buyNowModal').modal('show');
            $.spinner().stop();
        },
        error: function (error) {
            displayToasterMessage(error.statusText, 'error')
            $.spinner().stop();
        }
    });
})


$cache.body.on('click', 'button.buy-now', function (e) {
    e.preventDefault();
    var $form = $cache.body.find('form.place-order');
    var isFormValid = formValidation.validateForm($form);
    var isPDP = $productDetail.length > 0 ? true : false;
    var scrollTop = $form.offset().top;
    if (isFormValid) {
        var formData = formValidation.getForm($form);
        formData.isPDP = isPDP;
        $.spinner().start();
        $.ajax({
            type: 'POST',
            url: '/buyNow',
            data: formData,
            success: function (response) {
                if (response && response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
                $.spinner().stop();
            },
            error: function (error) {
                displayToasterMessage(getErrorMessage(error), "error")
                $.spinner().stop();
            }
        });
    } else {
        $('body, html').animate({ scrollTop: scrollTop - 80 }, 600);
    }
});

$cache.body.on('click', 'button.place-order', function (e) {
    e.preventDefault();
    var store = $productDetail.find('input#store').val()
    var isPDP = $productDetail.length > 0 ? true : false;
    var $form = $cache.body.find('form.place-order');
    if (isPDP) {
        $form = $cache.body.find('.cart-detail form.place-order');
    }
    var scrollTop = $form.offset().top;
    var isFormValid = formValidation.validateForm($form);
    if (isFormValid) {
        var formData = formValidation.getForm($form);
        formData.isPDP = isPDP;
        formData.store = store;
        $.spinner().start();
        $.ajax({
            type: 'POST',
            url: '/placeOrder',
            data: formData,
            success: function (response) {
                if (response && response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
                $.spinner().stop();
            },
            error: function (error) {
                displayToasterMessage(getErrorMessage(error), "error")
                $.spinner().stop();
            }
        });
    } else {
        if (isPDP) {
            $('#buyNowModal').animate({ scrollTop: scrollTop - 80 }, 600);
        } else {
            $('body, html').animate({ scrollTop: scrollTop - 80 }, 600);
        }
    }

});

// Select Shipping Method
$cache.body.on('change', 'input[name="shippingMethod"]', function(e) {
    e.preventDefault();
    const selectedMethodId = $(this).val();
    var isPDP = $productDetail.length > 0 ? true : false;
    $cartDetail.spinner().start();
    $.ajax({
        type: 'POST',
        url: '/selectShippingMethod',
        contentType: 'application/json',
        data: JSON.stringify({ selectedMethodId: selectedMethodId, isPDP : isPDP }),
        success: function (data) {
            // Optionally update the UI based on the response
            $cartDetail.find('.shipping .price').html(data.basket.totals.totalShippingCost.formatted);
            $cartDetail.find('.total .price').html(data.basket.totals.grandTotal.formatted);
            $cartDetail.spinner().stop();
        },
        error: function (error) {
            displayToasterMessage(getErrorMessage(error), "error")
            $cartDetail.spinner().stop();
        }
    });
});

$cache.body.on('click', '.product-tile', function(e) {
    var $target = $(e.target);
    if ($target.hasClass('carousel-control-next-icon') ||
        $target.hasClass('carousel-control-prev-icon') ||
        $target.hasClass('carousel-control-next') ||
        $target.hasClass('carousel-control-prev')) {
        return
    }
    var $this = $(this);
    var href = $this.find("[data-href]").data("href");
    if (href) {
        window.location.href = href;
    }
})

$cache.body.on('click', '.variation-values a', function(e) {
    $.spinner().start();
})

// custom test product
$productDetail.on('change', '.product-type-test input', function () {
    const variations = {};

    // Iterate over each variation element
    $cache.body.find('.product-type-test .variation').each(function () {
        const variableName = 'var_' + $(this).data('variable');
        const selectedValue = $(this).find('input:checked').val();
        variations[variableName] = selectedValue;
    });

    // Build the URL
    var quantity = $productDetail.find('.custom-quantity-selector input').val();
    const base_url = '/Product-Variation';
    const pid = $productDetail.data('pid');
    const queryParams = $.param({ pid: pid, qty: quantity, ...variations, test: true });
    const fullUrl = `${base_url}?${queryParams}`;
    var scrollTop = $productDetail.find('.product-price').offset().top;
    var variable = $(this).closest('.variation').data('variable');
    $.spinner().start();
    $.ajax({
        url: fullUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            updateProduct(data);
            // $('body, html').animate({ scrollTop: scrollTop - 80 }, 600);
            $('body').trigger('product:updateImages', {
                images: data.variationProduct.images.large,
                productId: data.variationProduct.id
            });
            $.spinner().stop();
        },
        error: function (error) {
            displayToasterMessage(getErrorMessage(error), "error")
            $.spinner().stop();
        }
    });
})

// Get the scrollable container
const scrollDiv = document.getElementById('scrollDiv');
if (scrollDiv) {
    scrollDiv.scrollLeft = 140;
}